import React from 'react';
import styled from 'styled-components';
import { HeaderDropdown } from './header-dropdown';

const HeaderDark = styled.div`
  /* too many different headers */
  color: #101938;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  width: 100%;
  // justify-content: space-between;
  // position: relative;
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  margin: 0;
  padding: 0;
`;

const FlexStart = styled(Flex)`
  height: ${(props) => (props.show ? '17px' : '0px')};
  justify-content: flex-start;
`;

const FlexEnd = styled(Flex)`
  height: 14px;
  justify-content: flex-end;

  .rs-dropdown {
    height: 14px;
    bottom: 7px;
  }
`;

// TODO: We should have a single card header component. It should be called Header
export function HeaderMd(props) {
  const { title, optionable = true, optionsOverride, onClickHandlers } = props;
  return (
    <HeaderDark>
      <FlexEnd>
        <HeaderDropdown
          show={optionable}
          optionsOverride={optionsOverride}
          onClickHandlers={onClickHandlers}
        />
      </FlexEnd>
      <FlexStart show={!!title}>
        <span>{title}</span>
      </FlexStart>
    </HeaderDark>
  );
}
